import { loadOptions } from '../../versa/formset.js';
import db from '../../versa/db.js';
import { keepSavedOrderPayment, readFormOrderId } from '../utils/keep-saved-order-payment.js';

// Requires observer.js
// Quando Pagamento = "Sem Pagamento" (90) ou Cliente tipo Local (L), Condição não é obrigatória (backend aceita null)
export default function (...args)
{

	let SHARED = { _this: null };

	return {

		_customerIsLocal: false,
		_paymentBind: { boundCustomerId: null },

		isRequired()
		{
			const pm = this.locate?.('payment_method')?.getValue?.();
			if (pm === '90' || pm === 90)
				return false;  // Sem Pagamento → Condição opcional
			if (this._customerIsLocal)
				return false;  // Cliente tipo Local (entrega) → Condição opcional
			return document.querySelector(this.selector)?.hasAttribute('required') ?? true;
		},

		async actions(ev, publisher, value)
		{
			switch (publisher.selector)
			{
				case '#company_id':
					await this.loadPaymentTerms(value);
					break;
				case '#customer_id':
					await this.setPaymentTerm(value);
					break;
			}
		},

		async loadPaymentTerms(company_id)
		{
			const action = async (company_id) =>
			{
				let payment_terms = await db.list('payment_terms', IDBKeyRange.bound([company_id, ''], [company_id, '\uffff']));
				loadOptions(this.selector, payment_terms, 'id', ['name']);
				this.refresh();
			}
			if (typeof company_id == 'string')
				this.preventMultiCalls(SHARED, action, () => this.refresh(), company_id);
		},

		async setPaymentTerm(customer_id)
		{
			let company_id = this.locate('company_id')?.getValue?.();
			const el = document.querySelector(this.selector);

			if (!company_id || company_id < 0 || !customer_id || customer_id === '' || customer_id < 0)
			{
				this._customerIsLocal = false;
				if (el)
				{
					el.removeAttribute('readonly');
					el.setAttribute('required', '');
				}
				return;
			}

			let customer = await db.get('customers', [company_id, Number(customer_id)]);
			const isLocal = customer?.type === 'L' || customer?.type?.toUpperCase?.() === 'L';
			const orderId = readFormOrderId(this);
			const keepSaved = keepSavedOrderPayment(this._paymentBind, orderId, customer_id);

			if (isLocal)
			{
				this._customerIsLocal = true;
				if (!keepSaved)
				{
					this.setValue?.('');
					this.refresh?.();
					this.locate?.('payment_method')?.setValue?.('90');
					this.locate?.('payment_method')?.refresh?.();
				}
				if (el)
				{
					el.setAttribute('readonly', '');
					el.removeAttribute('required');
				}
				this.checkErrorState?.();
				return;
			}

			this._customerIsLocal = false;
			if (el)
			{
				el.removeAttribute('readonly');
				el.setAttribute('required', '');
			}
			if (!keepSaved && customer?.payment_term_id != null && customer.payment_term_id !== '')
			{
				this.setValue(customer.payment_term_id);
				this.refresh();
			}
			this.checkErrorState?.();
		}

	};

}

